module.exports = __webpack_public_path__ + "static/media/image-not-available.be241dfd.svg";